export const DataRoles = [
  "Admin Sicepat",
  "Admin COD - Merger",
  "Admin GA",
  "Asset Management Staff",
  "Asisstant Manager General Affair",
  "Asset Management Supervisor",
  "Audit Internal",
  "Billing & Collection - Payment Admin",
  "Billing Admin",
  "Consumable Management Staff",
  "Consumable Management Supervisor",
  "Control Tower",
  "CT Return",
  "CS Monitoring",
  "Control Tower Denda",
  "GA - Staff Warehouse",
  "GA - Warehouse Staff",
  "HRD - Payroll",
  "HC Monitoring",
  "Industrial Engineer Manager",
  "Koordinator HUB",
  "Koordinator Hub",
  "koordinator checker",
  "Koordinator HUB Mesin",
  "IT Support Pusat",
  "IT Support Cabang",
  "IT support Create User",
  "Monitoring Operasional",
  "Marketing",
  "Ops - Admin COD",
  "Ops - Admin Hub",
  "Ops - Admin Bagging Transit",
  "Ops - Admin Malam",
  "Ops - Admin Operational ( COD )",
  "Ops - Admin Ops COD",
  "Ops - Admin COD",
  "Ops - Admin SMD",
  "ops - admin operational",
  "Ops - Admin Pengantaran",
  "Ops - Admin Luar Kota",
  "Ops - Admin Toko",
  "Ops - Admin.NEW",
  "Ops - Admin New",
  "Ops - Admin Mobile",
  "Ops - Admin Retur",
  "Ops - Admin SDS",
  "OPS - Admin Warehouse",
  "Ops - Bagging",
  "Ops - Customer Service",
  "Ops - Customer Service 1",
  "OPS - Claim",
  "Ops - COO",
  "Ops - Checker",
  "Ops - CS Mobile",
  "Ops - CT Line Haul",
  "Ops - Collection",
  "Ops - Driver Bandara",
  "Ops - Driver pickup",
  "Ops - Data Entry",
  "Ops - Driver",
  "Ops - Driver SMD",
  "Ops - Driver SDS",
  "Ops - First Mile Driver SDS",
  "Ops - First Mile Sigesit Pick Up",
  "Ops - First Mile Koordinator Pick Up",
  "Ops - First Mile Koordinator SDS",
  "Ops - First Mile Sigesit SDS",
  "Ops - First Mile Assitant Koordinator SDS",
  "Ops - First Mile Koordinator Sigesit Pick Up",
  "Ops - First Mile Koordinator Wilayah",
  "Ops - Helper",
  "Ops - Koordinator Operational",
  "Ops - Kepala Sigesit",
  "Ops - Kepala SMU",
  "Ops - Kepala Kurir SDS First Mile",
  "Ops - Kepala Kurir SDS Last Mile",
  "Ops - Koordinator Regional",
  "Ops - Koordinator Cabang",
  "OPS - Kordinator Line-Haul",
  "Ops - Koordinator Checker ",
  "Ops - Koordinator Checker",
  "Ops - Kepala Sorter",
  "OPS - Koordinator Toko / Drop Point",
  "Ops - Koordinator Sigesit Pick UP",
  "Ops - Koordinator wilayah HRD",
  "Ops - Last Mile Assitant Koordinator Sigesit",
  "Ops - Last Mile Driver",
  "Ops - Last Mile Driver SDS",
  "Ops - Last Mile Koordinator Sigesit (COD)",
  "Ops - Last Mile Assistant Koordinator ( COD )",
  "Ops - Last Mile Sigesit",
  "Ops - Last Mile Koordinator Wilayah",
  "Ops - Last Mile Koordinator Sigesit",
  "Ops - Last Mile Sigesit Transit",
  "Ops - Last Mile Koordinator SDS",
  "Ops - Last Mile Sigesit SDS",
  "Ops - Last Mile Assitant Koordinator SDS",
  "Ops - Last Mile Assitant Koordinator Sigesit New",
  "Ops - Last Mile Koordinator Sigesit New",
  "Ops - Last Mile Sorter New",
  "Ops - Laporan SMU",
  "OPS - Laporan Koordinator Malam",
  "Ops - Monitoring PickUp",
  "Ops - Return Staff",
  "Ops - SMD Dalam Kota",
  "Ops - Sorter Gerai",
  "OPS DARAT MP",
  "OPS - Sorter Pickup",
  "Ops - Sorter",
  "Ops - Operator SMU",
  "Ops - Sigesit pick UP",
  "Operatinal - Kepala SMU",
  "Operator SMU",
  "Root Cost Control",
  "Root HRD",
  "Root HRD Master Data",
  "Root CT",
  "Root IT",
  "ROOT IT COD",
  "Root Procurement",
  "Root Sales Marketing",
  "Root Business Process",
  "Root Business Analyst",
  "SMD Dalam Kota",
  "Sales",
  "Sales - Key Account Officer",
  "sales monitoring",
  "Senior Manager General Affair",
  "Senior Checker",
  "Superadmin",
];
